import "./assets/standard.scss";
import "./assets/popup.scss";
// import "./assets/slider.scss";
// import "./assets/popdown.scss";
import "./assets/sidetab.scss";
import "./assets/popover.scss";

import { CLOUD_PATH, PRODUCTION_VERSION } from "./globals";
import axios from "axios";

window.surveyResizeFrame = (className, height) => {
  const surveyFrame = document.getElementsByClassName(className);
  if (surveyFrame && surveyFrame.length > 0) {
    const parent = surveyFrame[0].closest(".survey-form-wrapper");
    parent.style.setProperty("--frameHeight", height + "px");
  }
};

function getFormVersionURL() {
  const serviceInfo = window.EB_SURVEY_FORM_SERVICE || {};

  console.log("EB_SURVEY_FORM_SERVICE == ", serviceInfo);
  const version = serviceInfo?.version && serviceInfo?.version;

  if (version && version == "localhost")
    return "http://localhost:3001/form_bundle/form_bundle.min.js";

  return (
    CLOUD_PATH +
    "survey-form/client/" +
    (version ? version : PRODUCTION_VERSION) +
    "/form_bundle/form_bundle.min.js"
  );
}

window.SURVEY_FORM_JSON = {};

const initializeSurvey = (ele) => {
  if (ele) {
    const encodedIds = ele.getAttribute("data-ebs-live");
    const decodedIds = atob(encodedIds);
    const idsArray = decodedIds.split(":");
    const formId = idsArray[0];
    const embedId = idsArray[1];
    if (formId) {
      getEmbedPrefs(embedId, formId, function (embedPrefs) {
        console.log("embedPrefs type ---- ", embedPrefs.type);
        console.log(
          "window.document.contains(ele) ---- ",
          window.document.getElementsByClassName("survey-form-wrapper")
        );
        getPreviewFormData(formId, (formData) => {
          SURVEY_FORM_JSON[formId] = formData;
          console.log("formData=>", formData);
          renderSurveyForm(ele, formId, embedPrefs, formData);
        });
      });
    }
  } else console.log("embed element not found!");
};

const getEmbedPrefs = (embedId, formId, callback) => {
  let embedPrefs;
  if (window.SURVEY_DESIGN_PROPS) {
    embedPrefs = window.SURVEY_DESIGN_PROPS;
    callback(embedPrefs);
  } else {
    fetch(
      "https://survey-form1-391207.wm.r.appspot.com/api/embbed/getbyid/" +
        embedId +
        "?formId=" +
        formId,
      {
        method: "GET",
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.isdefault) {
          data.settings = { width: "90%", height: "95%" };
        }
        embedPrefs = data;
        console.log("embedPrefs:", embedPrefs);
        if (callback) callback(embedPrefs);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      });
  }
};

function getRandomId() {
  return Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, "")
    .substr(2, 10);
}

function getEmbedTypeClassName(type) {
  return "form-type_" + type;
}
function getEmbedTypePosition(prefs) {
  return prefs.settings.position;
}

function renderSurveyForm(embedCodeEle, formId, prefs, formData) {
  if (embedCodeEle.childNodes.length || formData.data.draft) return;

  const type = prefs.type;
  let iconDiv = null;
  let initButton = null;
  let uniqueClassName = type + "-" + getRandomId() + "-" + new Date().getTime();

  let ele = document.createElement("div");
  ele.classList.add("survey-form-wrapper");
  ele.classList.add(getEmbedTypeClassName(type));

  if (prefs.settings.position) ele.classList.add(getEmbedTypePosition(prefs));

  const { margin, formBorder, boxShadow, formMaxWidth } =
    formData.data.bodySettings || {};

  // Set the properties using setProperty in a single step
  ele.style.setProperty("--marginTop", `${margin?.top}px`);
  ele.style.setProperty("--marginBottom", `${margin?.bottom}px`);
  ele.style.setProperty("--marginLeft", `${margin?.left}px`);
  ele.style.setProperty("--marginRight", `${margin?.right}px`);
  ele.style.setProperty(
    "--border",
    `${formBorder?.border.size}px ${formBorder?.border.style} ${formBorder?.border.color}`
  );
  ele.style.setProperty("--borderRadius", `${formBorder?.border.radius}px`);
  ele.style.setProperty(
    "--boxShadow",
    boxShadow?.enabled
      ? `${boxShadow?.horizontalLength}px ${boxShadow?.verticalLength}px ${boxShadow?.blurRadius}px ${boxShadow?.spreadRadius}px ${boxShadow?.color}`
      : `0px 0px 0px transparent`
  );
  ele.style.setProperty("--frameWidth", `${formMaxWidth}px`);

  // ele.style.setProperty(
  //   "--frameWidth",
  //   formData.data.bodySettings?.formMaxWidth + "px"
  // );
  // ele.style.setProperty(
  //   "--formRadius",
  //   formData.data.bodySettings?.formBorder?.border.radius + "px"
  // );
  // ele.style.setProperty(
  //   "--boxShadow",
  //   formData.data.bodySettings?.boxShadow?.enabled
  //     ? `${formData.data.bodySettings.boxShadow?.horizontalLength}px ${formData.data.bodySettings.boxShadow?.verticalLength}px ${formData.data.bodySettings.boxShadow?.blurRadius}px ${formData.data.bodySettings.boxShadow?.spreadRadius}px ${formData.data.bodySettings.boxShadow?.color}`
  //     : `0px 0px 0px transparent`
  // );

  embedCodeEle.appendChild(ele);

  function createButtons(ele, prefs) {
    let myIframe = null;
    let tooltip = null;
    let snippet = null;
    if (
      prefs.settings.advancedEnabled &&
      prefs.type !== "POPDOWN" &&
      prefs.type !== "SIDETAB"
    ) {
      eh_execute_when(prefs.settings, () => RenderFormUI());
      return;
    }

    console.log(prefs, "--Embed prefs");
    iconDiv = document.createElement("div");

    snippet = document.createElement("div");
    snippet.id = "snippet";
    snippet.classList.add("btn-container");

    if (
      prefs.settings.buttonToText &&
      prefs.type !== "POPDOWN" &&
      prefs.type !== "SIDETAB"
    ) {
      initButton = document.createElement("span");
      initButton.id = "in-btn";
      initButton.style.cssText =
        "font-family:Helvetica,Arial,sans-serif; display:inline-block; border:none; max-width:100%; overflow-wrap:break-word; color:" +
        prefs.settings.btnBgColor +
        "; font-size:" +
        parseInt(prefs.settings.fontSize, 10) +
        "px;   border-radius:" +
        parseInt(prefs.settings.btnRadius, 10) +
        "px; font-weight:bold; cursor:pointer; line-height:1; text-align:center; margin:0; text-decoration:underline; border:none;";
    } else {
      initButton = document.createElement("button");
      initButton.id = "in-btn";
      initButton.style.cssText =
        "font-family:Helvetica,Arial,sans-serif;display:inline-block;border:none; max-width:100%; overflow:hidden; overflow-wrap:break-word; background-color:" +
        prefs.settings.btnBgColor +
        "; color:#fff; font-size:" +
        parseInt(prefs.settings.fontSize, 10) +
        "px;   border-radius:" +
        parseInt(prefs.settings.btnRadius, 10) +
        "px; padding: 15px 25px 15px 25px; font-weight:bold; cursor:pointer; line-height:1; text-align:center; margin:0; text-decoration:none; border:none;";
    }

    initButton.innerHTML = prefs.settings.btnText
      ? prefs.settings.btnText
      : "Launch me";

    if (prefs.type === "SIDETAB") {
      initButton.innerHTML = "";
      const spanElement = document.createElement("span");
      spanElement.classList.add("span-in-btn");
      spanElement.innerHTML = prefs.settings.btnText
        ? prefs.settings.btnText
        : "Launch me";
      initButton.appendChild(spanElement);
      iconDiv.classList.add("ebs-sidetab-button-icon");
      iconDiv.innerHTML = `<img
            src=${prefs.settings.button_icon}
            alt="btn-icon"
            width="100%"
            height="90%"
          />`;

      initButton.style.cssText =
        "padding: 5px; line-height:1rem; overflow-wrap:break-word; background-color: " +
        prefs.settings.btnBgColor +
        "; color: rgb(255,255,255);";
      initButton.classList.add("ebs-sidetab-button");
      initButton.appendChild(iconDiv);
    } else if (prefs.type === "POPDOWN") {
      if (prefs.settings.greeting) {
        tooltip = document.createElement("div");
        tooltip.id = "tooltip";
        tooltip.classList.add("ebs-popdown-tooltip");
        const tooltipText = document.createElement("div");
        tooltipText.id = "tip-text";
        tooltipText.classList.add("ebs-popdown-tooltip-text");
        tooltipText.innerText = prefs.settings.greetingMsg
          ? prefs.settings.greetingMsg
          : "Hey! Open me...";
        tooltip.appendChild(tooltipText);
        const closeTip = document.createElement("span");
        closeTip.classList.add("ebs-popdown-tooltip-close");
        closeTip.innerText = "×";
        tooltip.appendChild(closeTip);
        closeTip.onclick = () => {
          tooltip.style.display = "none";
        };
        snippet.appendChild(tooltip);
      }
      iconDiv.classList.add("ebs-popdown-button-icon");
      iconDiv.innerHTML = `<img
          src=${prefs.settings.button_icon}
          alt="btn-icon"
          width="85%"
          height="85%"
        />`;

      initButton.textContent = "";
      initButton.style.cssText =
        "background-color: " +
        prefs.settings.btnBgColor +
        "; color: rgb(255,255,255);";
      initButton.classList.add("ebs-popdown-button");
      initButton.appendChild(iconDiv);
    }

    myIframe = window.parent.document.getElementById("my-iframe");
    if (myIframe === null) {
      snippet.classList.add("embedded");
    }

    snippet.appendChild(initButton);
    ele.appendChild(snippet);

    initButton.onclick = () => {
      RenderFormUI();
    };
  }

  const RenderFormUI = () => {
    if (
      !prefs.settings.advancedEnabled &&
      prefs.type !== "SIDETAB" &&
      prefs.type !== "POPDOWN" &&
      prefs.type !== "EMBED"
    ) {
      if (snippet.length > 0) {
        [...snippet].forEach((sp) => {
          sp.style.cssText = "display:none;";
        });
      } else snippet.style.cssText = "display:none;";
    }

    // If embed of same 'type', 'position' and 'popup_rule' is already shown, then return immediately.
    if (
      type !== "EMBED" &&
      document.querySelectorAll(
        ".survey-form-wrapper." +
          getEmbedTypeClassName(type) +
          "." +
          getEmbedTypePosition(prefs) +
          ".open"
      ).length > 0
    )
      return;

    if (prefs.type === "POPDOWN" || prefs.type === "SIDETAB") {
      if (prefs.type === "POPDOWN" && prefs.settings.greeting)
        tooltip.style.display = "none";
      iconDiv.innerHTML = "&#x2715;";
      initButton.appendChild(iconDiv);

      initButton.onclick = () => closeForm();
    }

    // If it is already shown, then return immediately (no need to create sfContainer again).
    if (ele.getElementsByClassName("survey-frame-container").length > 0) {
      ele
        .getElementsByClassName("survey-frame-container")[0]
        .classList.remove("hide");
      ele.classList.add("open");
      return;
    }

    let sfContainer = document.createElement("div");
    sfContainer.classList.add("survey-frame-container");
    sfContainer.classList.add("hide");
    sfContainer.classList.add(
      prefs.settings.animationType || "default-animation"
    );
    ele.classList.add("open");

    ele.appendChild(sfContainer);

    let surveyIframe = document.createElement("iframe");
    surveyIframe.id = "sf-iframe";
    surveyIframe.classList.add(uniqueClassName);

    surveyIframe.onload = function () {
      let html = `
      <head>
        <!-- Add your head content here if needed -->
      </head>
      <body>
        <div id="app"></div>
        <script>
          var formID = '${formId}';
          var frameClass = '${uniqueClassName}';
        </script>
        <script src='${getFormVersionURL()}'>
  
        </script>
      </body>`;

      let frameDoc =
        sfContainer.getElementsByTagName("iframe")[0].contentWindow;
      frameDoc.document.open();
      frameDoc.document.write("<!DOCTYPE html>");
      frameDoc.document.write(html);
      frameDoc.document.close();

      setTimeout(() => {
        sfContainer.classList.remove("hide");
      }, 5);
    };
    sfContainer.appendChild(surveyIframe);

    if (
      prefs.type === "SLIDER" ||
      prefs.type === "POPUP" ||
      prefs.type === "POPOVER"
    ) {
      let closeIconBtn = document.createElement("button");
      closeIconBtn.textContent = "×";
      closeIconBtn.classList.add("ebs-close", "ebs-close-icon");
      if (prefs.type === "POPUP")
        surveyIframe.style.maxHeight =
          prefs.settings.popupDimensions?.height + "%";

      closeIconBtn.onclick = () => closeForm();
      setTimeout(() => {
        sfContainer.appendChild(closeIconBtn);
      }, 100);
    }
  };

  function closeForm() {
    if (prefs.type === "SIDETAB" || prefs.type === "POPDOWN") {
      iconDiv.innerHTML = `<img
        src=${prefs.settings.button_icon}
        alt="btn-icon"
        width="100%"
        height="90%"
      />`;
      initButton.onclick = () => {
        RenderFormUI();
      };
    }
    ele.classList.remove("open");

    // Hide sfContainer
    ele
      .getElementsByClassName("survey-frame-container")[0]
      .classList.add("hide");

    if (
      !prefs.settings.advancedEnabled &&
      prefs.type !== "SIDETAB" &&
      prefs.type !== "POPDOWN"
    ) {
      if (snippet.length > 0) {
        [...snippet].forEach((sp) => {
          sp.style.cssText = "display:auto;";
        });
      } else snippet.style.cssText = "display:auto;";
    }
  }

  switch (type) {
    case "EMBED":
      RenderFormUI();
      break;

    case "FULLPAGE":
      RenderFormUI();
      break;

    case "POPUP":
      createButtons(ele, prefs);
      break;

    case "SLIDER":
      createButtons(ele, prefs);
      break;

    case "POPDOWN":
      createButtons(ele, prefs);
      break;

    case "SIDETAB":
      createButtons(ele, prefs);
      break;

    case "POPOVER":
      createButtons(ele, prefs);
      break;

    default:
      console.log("Unknown embed type");
      break;
  }
}

// functions for display-rules...
function eh_execute_when(action, callback) {
  console.log("eh_execute_when called.");
  // NONE
  if (!action.advancedEnabled) {
    return;
  }
  // On Page Load
  if (action.popup_pattern == "On Page Load") {
    callback();
  }
  // Exit Intent
  if (action.popup_pattern == "Exit Intent") {
    eh_exit_intent(function () {
      callback();
      return;
    });
  }
  // On Scroll
  if (action.popup_pattern == "Scroll") {
    window.onscroll = function () {
      if (eh_get_scroll_percent() >= action.scroll_percentage) {
        callback();
        window.onscroll = null;
      }
    };
    return;
  }
  // Time Interval
  if (action.popup_pattern == "Delay") {
    setTimeout(callback, action.delay_timer * 1000);
    return;
  }
}

//////////////////////////////////
function eh_get_scroll_percent() {
  var h = document.documentElement,
    b = document.body,
    st = "scrollTop",
    sh = "scrollHeight";
  return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
}

var _eh_mouseY; // Initialize mouseY
var _eh_exit_intent_shown = false; // Do not show exit intent once it's shown

// Calls callback when the visitor tries to abandons
function eh_exit_intent(callback) {
  if (eh_is_browser("Firefox")) eh_exit_intent_firefox(callback);
  else if (eh_is_browser("MSIE") || eh_is_browser("Trident"))
    eh_exit_intent_ie(callback);
  else {
    if (document.addEventListener) {
      document.addEventListener("mousemove", function (e) {
        _eh_mouseY = e.pageY;
        var scrollY =
          typeof window.pageYOffset != "undefined"
            ? window.pageYOffset
            : document.documentElement.scrollTop
            ? document.documentElement.scrollTop
            : document.body.scrollTop
            ? document.body.scrollTop
            : 0;
        if (_eh_mouseY < scrollY + 20) {
          if (_eh_exit_intent_shown == false) {
            _eh_exit_intent_shown = true;
            callback();
          }
        }
      });
    }
  }

  //mobile exit intent detection
  history.pushState(null, "", window.location.href);
  window.addEventListener("popstate", function (event) {
    // Show the form popup before going back
    if (_eh_exit_intent_shown == false) {
      _eh_exit_intent_shown = true;
      callback();
      history.pushState(null, "", window.location.href);
    }
  });
}

function eh_exit_intent_firefox(callback) {
  document.addEventListener("mouseout", function (e) {
    if (e.relatedTarget == null) {
      if (_eh_exit_intent_shown == false) {
        _eh_exit_intent_shown = true;
        callback();
      }
    }
  });
}

function eh_is_browser(e) {
  try {
    return window.navigator.userAgent.indexOf(e) != -1;
  } catch (t) {}
}

// Exit intent for ie
function eh_exit_intent_ie(callback) {
  if (document.attachEvent) {
    document.attachEvent("onmouseout", function (e) {
      if (e.toElement == null) {
        if (eh_exit_intent == false) {
          eh_exit_intent = true;
          callback();
        }
      }
    });
  } else if (document.addEventListener) {
    document.addEventListener("mouseout", function (e) {
      if (e.toElement == null) {
        if (eh_exit_intent == false) {
          eh_exit_intent = true;
          callback();
        }
      }
    });
  }
}

// get formData by id
const getPreviewFormData = (id, callback) => {
  try {
    const BASE_URL = "https://survey-form1-391207.wm.r.appspot.com/api";
    const response = axios.get(BASE_URL + "/list/readById/" + id);
    response.then(function (resp) {
      console.log("callback res=>", resp);
      return callback(resp);
    });
  } catch (err) {
    throw new Error(err.message);
  }
};

// In initialize
(() => {
  const elements = document.querySelectorAll("div[data-ebs-live]");
  elements.forEach((element) => {
    // If already initialized, return immediately
    if (element.childNodes.length) return;

    initializeSurvey(element);
  });
})();
